<template>


    <section class="container-fluid" id="parent">
        <h1 class="page-heading">{{ store.lexicon[store.culture].PRRequestHead }}</h1>

        <div class="mb-5">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-tabs btn-group mb-4" role="group">
                        <button type="button" :class="['btn', store.currentPage == 'REQUESTOR' ? 'btn-outline-primary' : 'btn-primary']" @click="goBackToPage('REQUESTOR')">
                            {{ store.lexicon[store.culture].PRFormPage1 }}
                            <span class="badge bg-danger ms-2" v-if="errorCount('REQUESTOR') > 0">{{ errorCount('REQUESTOR') }}</span>
                        </button>
                        <button type="button" :class="['btn', store.currentPage == 'BACKGROUND' ? 'btn-outline-primary' : 'btn-primary']" @click="goBackToPage('BACKGROUND')">
                            {{ store.lexicon[store.culture].PRFormPage2 }}
                            <span class="badge bg-danger ms-2" v-if="errorCount('BACKGROUND') > 0">{{ errorCount('BACKGROUND') }}</span>
                        </button>
                        <button type="button" :class="['btn', store.currentPage == 'TYPE' ? 'btn-outline-primary' : 'btn-primary']" @click="goBackToPage('TYPE')">
                            {{ store.lexicon[store.culture].PRFormPage3 }}
                            <span class="badge bg-danger ms-2" v-if="errorCount('TYPE') > 0">{{ errorCount('TYPE') }}</span>
                        </button>
                        <button v-for="(type, index) in store.formData.Types" type="button" :class="['btn', store.currentPage == 'TYPEPAGE' && store.currentTypePage == index ? 'btn-outline-primary' : 'btn-primary']" @click="goBackToTypePage(index)">
                            {{ type }}
                            <span class="badge bg-danger ms-2" v-if="errorCount(type) > 0">{{ errorCount(type) }}</span>
                        </button>
                        <button type="button" :class="['btn', store.currentPage == 'FINISH' ? 'btn-outline-primary' : 'btn-primary']" @click="goBackToPage('FINISH')">
                            {{ store.lexicon[store.culture].PRFormPage4 }}
                        </button>
                    </div>
                </div>
            </div>

            <Requestor v-if="store.currentPage == 'REQUESTOR'" @goToPage="goToPage" @goBackToPage="goBackToPage" @validatePage="validatePage" />
            <Background v-if="store.currentPage == 'BACKGROUND'" @goToPage="goToPage" @goBackToPage="goBackToPage" @validatePage="validatePage" />
            <Type v-if="store.currentPage == 'TYPE'" @goToPage="goToPage" @goBackToPage="goBackToPage" @goToTypePage="goToTypePage" />
            <TypePolice v-if="store.currentPage == 'TYPEPAGE' && store.formData.Types[store.currentTypePage] == 'Police'" @goToPage="goToPage" @goBackToPage="goBackToPage" @goToTypePage="goToTypePage" @goBackToTypePage="goBackToTypePage" @validatePage="validatePage" />
            <TypeEmergency v-if="store.currentPage == 'TYPEPAGE' && store.formData.Types[store.currentTypePage] == 'Emergency'" @goToPage="goToPage" @goBackToPage="goBackToPage" @goToTypePage="goToTypePage" @goBackToTypePage="goBackToTypePage" @validatePage="validatePage" />
            <TypeCctv v-if="store.currentPage == 'TYPEPAGE' && store.formData.Types[store.currentTypePage] == 'CCTV'" @goToPage="goToPage" @goBackToPage="goBackToPage" @goToTypePage="goToTypePage" @goBackToTypePage="goBackToTypePage" @validatePage="validatePage" />
            <TypeBodycam v-if="store.currentPage == 'TYPEPAGE' && store.formData.Types[store.currentTypePage] == 'Bodycam'" @goToPage="goToPage" @goBackToPage="goBackToPage" @goToTypePage="goToTypePage" @goBackToTypePage="goBackToTypePage" @validatePage="validatePage" />
            <TypeMedical v-if="store.currentPage == 'TYPEPAGE' && store.formData.Types[store.currentTypePage] == 'Medical'" @goToPage="goToPage" @goBackToPage="goBackToPage" @goToTypePage="goToTypePage" @goBackToTypePage="goBackToTypePage" @validatePage="validatePage" />
            <TypeAccess v-if="store.currentPage == 'TYPEPAGE' && store.formData.Types[store.currentTypePage] == 'Access'" @goToPage="goToPage" @goBackToPage="goBackToPage" @goToTypePage="goToTypePage" @goBackToTypePage="goBackToTypePage" @validatePage="validatePage" />
            <TypeContract v-if="store.currentPage == 'TYPEPAGE' && store.formData.Types[store.currentTypePage] == 'Contract'" @goToPage="goToPage" @goBackToPage="goBackToPage" @goToTypePage="goToTypePage" @goBackToTypePage="goBackToTypePage" @validatePage="validatePage" />
            <TypeOther v-if="store.currentPage == 'TYPEPAGE' && store.formData.Types[store.currentTypePage] == 'Other'" @goToPage="goToPage" @goBackToPage="goBackToPage" @goToTypePage="goToTypePage" @goBackToTypePage="goBackToTypePage" @validatePage="validatePage" />
            <Finish v-if="store.currentPage == 'FINISH'" @goBackToPage="goBackToPage" @goBackToTypePage="goBackToTypePage" :isDayJS="isDayJS" :formatDate="formatDate" :validateAll="validateAll" />
            <Success v-if="store.currentPage == 'SUCCESS'" />
        </div>
    </section>

</template>

<script setup>
    import * as dayjs from 'dayjs';
    import { computed } from 'vue';
    import { useStore } from './store';
    import Requestor from './requestor';
    import Background from './background';
    import Type from './type';
    import TypePolice from './type_police';
    import TypeEmergency from './type_emergency';
    import TypeCctv from './type_cctv';
    import TypeBodycam from './type_bodycam';
    import TypeMedical from './type_medical';
    import TypeAccess from './type_access';
    import TypeContract from './type_contract';
    import TypeOther from './type_other';
    import Finish from './finish';
    import Success from './success';

    const store = useStore();

    function errorCount(page) {
        var errorCount = 0;

        switch (page) {
            case "REQUESTOR":
                if (store.errors.FirstName) errorCount++;
                if (store.errors.LastName) errorCount++;
                if (store.errors.PhoneNumber) errorCount++;
                if (store.errors.Email) errorCount++;
                break;
            case "BACKGROUND":
                if (store.errors.ForGovernment) errorCount++;
                if (store.errors.ForMedia) errorCount++;
                if (store.errors.ForLegal) errorCount++;
                break;
            case "TYPE":
                if (store.errors.Types) errorCount++;
                break;
            case "Police":
                if (store.errors.Police.PersonInvolvedName) errorCount++;
                if (store.errors.Police.PersonInvolvedDob) errorCount++;
                if (store.errors.Police.PersonInvolvedRelation) errorCount++;
                if (store.errors.Police.IncidentDate) errorCount++;
                if (store.errors.Police.IncidentLocation) errorCount++;
                if (store.errors.Police.Details) errorCount++;
                break;
            case "Emergency":
                if (store.errors.Emergency.Types) errorCount++;
                if (store.errors.Emergency.IncidentDateTime) errorCount++;
                if (store.errors.Emergency.Details) errorCount++;
                if (store.errors.Emergency.IncidentRelationship) errorCount++;
                break;
            case "CCTV":
                if (store.errors.Cctv.IncidentDate) errorCount++;
                if (store.errors.Cctv.IncidentTime) errorCount++;
                if (store.errors.Cctv.Location) errorCount++;
                if (store.errors.Cctv.Details) errorCount++;
                if (store.errors.Cctv.Reason) errorCount++;
                break;
            case "Bodycam":
                if (store.errors.Bodycam.IncidentDate) errorCount++;
                if (store.errors.Bodycam.IncidentTime) errorCount++;
                if (store.errors.Bodycam.IncidentDescription) errorCount++;
                if (store.errors.Bodycam.Reason) errorCount++;
                break;
            case "Medical":
                if (store.errors.Medical.ParientName) errorCount++;
                if (store.errors.Medical.IncidentDate) errorCount++;
                if (store.errors.Medical.IncidentTime) errorCount++;
                if (store.errors.Medical.IncidentLocation) errorCount++;
                if (store.errors.Medical.AssistanceLocation) errorCount++;
                break;
            case "Access":
                if (store.errors.Access.Details) errorCount++;
                if (store.errors.Access.BadgeholderName) errorCount++;
                if (store.errors.Access.BadgeNumber) errorCount++;
                if (store.errors.Access.Upid) errorCount++;
                if (store.errors.Access.DatesAndTimes) errorCount++;
                break;
            case "Contract":
                if (store.errors.Contract.ProjectTitle) errorCount++;
                if (store.errors.Contract.RequestedRecords) errorCount++;
                break;
            case "Other":
                if (store.errors.Other.Details) errorCount++;
                break;
        }

        return errorCount;
    }

    function goBackToPage(pageName) {
        store.currentPage = pageName;
        scrollToTop();

        if (pageName == "FINISH") {
            validateAll();
        }
    }

    function goToPage(pageName) {
        if (store.currentPage == 'TYPEPAGE') {
            if (validatePage(store.formData.Types[store.currentTypePage])) {
                store.currentPage = pageName;
                scrollToTop();
                setPageProgress(pageName);
            }
        }
        else {
            if (validatePage(store.currentPage)) {
                store.currentPage = pageName;
                scrollToTop();
                setPageProgress(pageName);
            }
        }

        if (pageName == "FINISH") {
            validateAll();
        }
    }

    function goBackToTypePage(index) {
        store.currentPage = 'TYPEPAGE';
        store.currentTypePage = index;
        scrollToTop();
    }

    function goToTypePage(index) {
        var stay = false;

        if (store.currentPage != 'TYPEPAGE') {
            if (!validatePage(store.currentPage)) {
                stay = true;
            }
        }
        else {
            if (!validatePage(store.formData.Types[store.currentTypePage])) {
                stay = true;
            }
        }

        if (!stay) {
            store.currentPage = 'TYPEPAGE';
            store.currentTypePage = index;
            scrollToTop();
            if (store.progressTypePage < index) {
                store.progressTypePage = index;
            }
        }
    }

    function setPageProgress(pageName) {
        switch (pageName) {
            case 'BACKGROUND':
                if (store.progressPage < 1) {
                    store.progressPage = 1;
                }
                break;

            case 'TYPE':
                if (store.progressPage < 2) {
                    store.progressPage = 2;
                }
                break;

            case 'SUBMIT':
                if (store.progressPage < 4) {
                    store.progressPage = 4;
                }
                break;
        }
    }

    function validatePage(pageName, fieldName = null) {
        var isError = false;

        if (pageName == 'REQUESTOR') {
            if (fieldName == null || fieldName == 'firstName') {
                if (store.formData.FirstName.trim() == "") {
                    store.errors.FirstName = true;
                    isError = true;
                }
                else {
                    store.errors.FirstName = false;
                }
            }

            if (fieldName == null || fieldName == 'lastName') {
                if (store.formData.LastName.trim() == "") {
                    store.errors.LastName = true;
                    isError = true;
                }
                else {
                    store.errors.LastName = false;
                }
            }

            if (fieldName == null || fieldName == 'phoneNumber') {
                if (store.formData.PhoneNumber.trim() != "") {
                    const phoneRegex = /^\d{10}$/;
                    if (!phoneRegex.test(store.formData.PhoneNumber)) {
                        store.errors.PhoneNumber = true;
                        isError = true;
                    }
                    else {
                        store.errors.PhoneNumber = false;
                    }
                }
                else {
                    store.errors.PhoneNumber = false;
                }
            }

            if (fieldName == null || fieldName == 'email') {
                if (store.formData.Email.trim() == "") {
                    store.errors.Email = true;
                    isError = true;
                }
                else {
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (emailRegex.test(store.formData.Email)) {
                        store.errors.Email = false;
                    }
                    else {
                        store.errors.Email = true;
                        isError = true;
                    }
                }
            }
        }
        else if (pageName == 'BACKGROUND') {

            if (fieldName == null || fieldName == 'forGovernment') {
                if (store.formData.ForGovernment == null) {
                    store.errors.ForGovernment = true;
                    isError = true;
                }
                else {
                    store.errors.ForGovernment = false;
                }
            }

            if (fieldName == null || fieldName == 'forMedia') {
                if (store.formData.ForMedia == null) {
                    store.errors.ForMedia = true;
                    isError = true;
                }
                else {
                    store.errors.ForMedia = false;
                }
            }

            if (fieldName == null || fieldName == 'forLegal') {
                if (store.formData.ForLegal == null) {
                    store.errors.ForLegal = true;
                    isError = true;
                }
                else {
                    store.errors.ForLegal = false;
                }
            }
        }
        else if (pageName == 'TYPE') {
            if (store.formData.Types.length == 0) {
                store.errors.Types = true;
                isError = true;
            }
            else {
                store.errors.Types = false;
            }
        }
        else if (pageName == 'Police') {

            if (fieldName == null || fieldName == 'personInvolvedName') {
                if (store.formData.Police.PersonInvolvedName.trim() == "") {
                    store.errors.Police.PersonInvolvedName = true;
                    isError = true;
                }
                else {
                    store.errors.Police.PersonInvolvedName = false;
                }
            }

            if (fieldName == null || fieldName == 'personInvolvedDob') {
                if (store.formData.Police.PersonInvolvedDob == "") {
                    store.errors.Police.PersonInvolvedDob = true;
                    isError = true;
                }
                else {
                    store.errors.Police.PersonInvolvedDob = false;
                }
            }

            if (fieldName == null || fieldName == 'personInvolvedRelation') {
                if (store.formData.Police.PersonInvolvedRelation.trim() == "") {
                    store.errors.Police.PersonInvolvedRelation = true;
                    isError = true;
                }
                else {
                    store.errors.Police.PersonInvolvedRelation = false;
                }
            }

            if (fieldName == null || fieldName == 'incidentDate') {
                if (store.formData.Police.IncidentDate == "") {
                    store.errors.Police.IncidentDate = true;
                    isError = true;
                }
                else {
                    store.errors.Police.IncidentDate = false;
                }
            }

            if (fieldName == null || fieldName == 'incidentLocation') {
                if (store.formData.Police.IncidentLocation.trim() == "") {
                    store.errors.Police.IncidentLocation = true;
                    isError = true;
                }
                else {
                    store.errors.Police.IncidentLocation = false;
                }
            }

            if (fieldName == null || fieldName == 'details') {
                if (store.formData.Police.Details.trim() == "") {
                    store.errors.Police.Details = true;
                    isError = true;
                }
                else {
                    store.errors.Police.Details = false;
                }
            }
        }
        else if (pageName == 'Emergency') {

            if (fieldName == null || fieldName == 'types') {
                if (store.formData.Emergency.Types.length == 0) {
                    store.errors.Emergency.Types = true;
                    isError = true;
                }
                else {
                    store.errors.Emergency.Types = false;
                }
            }

            if (fieldName == null || fieldName == 'incidentDateTime') {
                if (store.formData.Emergency.IncidentDateTime.trim() == "") {
                    store.errors.Emergency.IncidentDateTime = true;
                    isError = true;
                }
                else {
                    store.errors.Emergency.IncidentDateTime = false;
                }
            }

            if (fieldName == null || fieldName == 'details') {
                if (store.formData.Emergency.Details.trim() == "") {
                    store.errors.Emergency.Details = true;
                    isError = true;
                }
                else {
                    store.errors.Emergency.Details = false;
                }
            }

            if (fieldName == null || fieldName == 'incidentRelationship') {
                if (store.formData.Emergency.IncidentRelationship.trim() == "") {
                    store.errors.Emergency.IncidentRelationship = true;
                    isError = true;
                }
                else {
                    store.errors.Emergency.IncidentRelationship = false;
                }
            }
        }
        else if (pageName == 'CCTV') {

            if (fieldName == null || fieldName == 'incidentDate') {
                if (store.formData.Cctv.IncidentDate == "") {
                    store.errors.Cctv.IncidentDate = true;
                    isError = true;
                }
                else {
                    store.errors.Cctv.IncidentDate = false;
                }
            }

            if (fieldName == null || fieldName == 'incidentTime') {
                if (store.formData.Cctv.IncidentTime.trim() == "") {
                    store.errors.Cctv.IncidentTime = true;
                    isError = true;
                }
                else {
                    store.errors.Cctv.IncidentTime = false;
                }
            }

            if (fieldName == null || fieldName == 'location') {
                if (store.formData.Cctv.Location.trim() == "") {
                    store.errors.Cctv.Location = true;
                    isError = true;
                }
                else {
                    store.errors.Cctv.Location = false;
                }
            }

            if (fieldName == null || fieldName == 'details') {
                if (store.formData.Cctv.Details.trim() == "") {
                    store.errors.Cctv.Details = true;
                    isError = true;
                }
                else {
                    store.errors.Cctv.Details = false;
                }
            }

            if (fieldName == null || fieldName == 'reason') {
                if (store.formData.Cctv.Reason.trim() == "") {
                    store.errors.Cctv.Reason = true;
                    isError = true;
                }
                else {
                    store.errors.Cctv.Reason = false;
                }
            }
        }
        else if (pageName == 'Bodycam') {

            if (fieldName == null || fieldName == 'incidentDate') {
                if (store.formData.Bodycam.IncidentDate == "") {
                    store.errors.Bodycam.IncidentDate = true;
                    isError = true;
                }
                else {
                    store.errors.Bodycam.IncidentDate = false;
                }
            }

            if (fieldName == null || fieldName == 'incidentTime') {
                if (store.formData.Bodycam.IncidentTime.trim() == "") {
                    store.errors.Bodycam.IncidentTime = true;
                    isError = true;
                }
                else {
                    store.errors.Bodycam.IncidentTime = false;
                }
            }

            if (fieldName == null || fieldName == 'incidentDescription') {
                if (store.formData.Bodycam.IncidentDescription.trim() == "") {
                    store.errors.Bodycam.IncidentDescription = true;
                    isError = true;
                }
                else {
                    store.errors.Bodycam.IncidentDescription = false;
                }
            }

            if (fieldName == null || fieldName == 'reason') {
                if (store.formData.Bodycam.Reason.trim() == "") {
                    store.errors.Bodycam.Reason = true;
                    isError = true;
                }
                else {
                    store.errors.Bodycam.Reason = false;
                }
            }
        }
        else if (pageName == 'Medical') {
            if (fieldName == null || fieldName == 'patientName') {
                if (store.formData.Medical.PatientName.trim() == "") {
                    store.errors.Medical.PatientName = true;
                    isError = true;
                }
                else {
                    store.errors.Medical.PatientName = false;
                }
            }

            if (fieldName == null || fieldName == 'incidentDate') {
                if (store.formData.Medical.IncidentDate == "") {
                    store.errors.Medical.IncidentDate = true;
                    isError = true;
                }
                else {
                    store.errors.Medical.IncidentDate = false;
                }
            }

            if (fieldName == null || fieldName == 'incidentTime') {
                if (store.formData.Medical.IncidentTime.trim() == "") {
                    store.errors.Medical.IncidentTime = true;
                    isError = true;
                }
                else {
                    store.errors.Medical.IncidentTime = false;
                }
            }

            if (fieldName == null || fieldName == 'incidentLocation') {
                if (store.formData.Medical.IncidentLocation.trim() == "") {
                    store.errors.Medical.IncidentLocation = true;
                    isError = true;
                }
                else {
                    store.errors.Medical.IncidentLocation = false;
                }
            }
        }
        else if (pageName == 'Access') {

            if (fieldName == null || fieldName == 'details') {
                if (store.formData.Access.Details.trim() == "") {
                    store.errors.Access.Details = true;
                    isError = true;
                }
                else {
                    store.errors.Access.Details = false;
                }
            }

            if (fieldName == null || fieldName == 'badgeholderName') {
                if (store.formData.Access.BadgeholderName.trim() == "") {
                    store.errors.Access.BadgeholderName = true;
                    isError = true;
                }
                else {
                    store.errors.Access.BadgeholderName = false;
                }
            }

            if (fieldName == null || fieldName == 'badgeNumber') {
                if (store.formData.Access.BadgeNumber.trim() == "") {
                    store.errors.Access.BadgeNumber = true;
                    isError = true;
                }
                else {
                    store.errors.Access.BadgeNumber = false;
                }
            }

            if (fieldName == null || fieldName == 'upid') {
                if (store.formData.Access.Upid.trim() == "") {
                    store.errors.Access.Upid = true;
                    isError = true;
                }
                else {
                    store.errors.Access.Upid = false;
                }
            }

            if (fieldName == null || fieldName == 'datesAndTimes') {
                if (store.formData.Access.DatesAndTimes.trim() == "") {
                    store.errors.Access.DatesAndTimes = true;
                    isError = true;
                }
                else {
                    store.errors.Access.DatesAndTimes = false;
                }
            }
        }
        else if (pageName == 'Contract') {
            if (fieldName == null || fieldName == 'projectTitle') {
                if (store.formData.Contract.ProjectTitle.trim() == "") {
                    store.errors.Contract.ProjectTitle = true;
                    isError = true;
                }
                else {
                    store.errors.Contract.ProjectTitle = false;
                }
            }

            if (fieldName == null || fieldName == 'requestedRecords') {
                if (store.formData.Contract.RequestedRecords.length == 0) {
                    store.errors.Contract.RequestedRecords = true;
                    isError = true;
                }
                else {
                    store.errors.Contract.RequestedRecords = false;
                }
            }
        }
        else if (pageName == 'Other') {
            if (fieldName == null || fieldName == 'details') {
                if (store.formData.Other.Details.trim() == "") {
                    store.errors.Other.Details = true;
                    isError = true;
                }
                else {
                    store.errors.Other.Details = false;
                }
            }
        }

        return !isError;
    }

    function isDayJS(dateTime) {
        return dayjs(dateTime).isValid();
    }

    function formatDate(dateTime) {
        return dayjs(dateTime).format('MM/DD/YYYY');
    }

    function validateAll() {
        store.errors.AnyError = !validatePage('REQUESTOR');
        store.errors.AnyError = !validatePage('BACKGROUND') || store.errors.AnyError;
        store.errors.AnyError = !validatePage('TYPE') || store.errors.AnyError;
        for (var i = 0; i < store.formData.Types.length; i++) {
            store.errors.AnyError = !validatePage(store.formData.Types[i]) || store.errors.AnyError;
        }

        if (store.errors.AnyError) {
            return false;
        }

        return true;
    }

    function scrollToTop() {
        window.scrollTo(0, 0);
    }

</script>